<template>
  <div class="view" ref="chart"></div>
</template>

<script>
  export default {
    name: "bar1",
    props: [
      'xData',
      'yData',
      'yLabel',
      'xLabel',
      'name',
      'type'
    ],
    data() {
      return {
        option:{}
      }
    },
    created() {
      this.option=  {
        title: {
          left: 26,
            top: 10,
            text: this.name,
            itemGap: 4,
            textStyle: {
            color: '#454B60',
              fontSize: 18,
              fontWeight: 'bold',
              lineHeight: 18
          },
          subtextStyle: {
            color: '#999999',
              fontSize: 12,
              fontFamily: 'Microsoft YaHei'
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
            data: [],
            axisLabel: {
            formatter: '{value}' //刻度标签的内容格式器，支持字符串模板和回调函数两种形式，按照自己需求设置
          },
        },
        yAxis: {
          type: 'value',
            axisLabel: {
            formatter: '{value}' //刻度标签的内容格式器，支持字符串模板和回调函数两种形式，按照自己需求设置
          },
        },
        series: [
          {
            data: [],
            type: this.type,
            smooth: true
          }
        ]
      }
    },
    watch: {
      xData:{
          handler:function(newValue) {
              this.option.xAxis.data = newValue.map((item)=>(item.x))
              this.echartInstance.setOption(this.option)
          },
          deep:true
      },
      yData:{
        handler:function (newValue) {
          this.option.series[0].data = newValue.map((item)=>(item.y))
          this.echartInstance.setOption(this.option)
        },
        deep:true
      },
      xLabel(newValue) {
        this.option.xAxis.axisLabel.formatter = `{value}${newValue}`
        this.echartInstance.setOption(this.option)
      },
      yLabel(newValue) {
        this.option.yAxis.axisLabel.formatter = `{value}${newValue}`
        this.echartInstance.setOption(this.option)
      },
      name:{
        handler:function (newValue) {
          this.option.title.text = newValue
          this.echartInstance.setOption(this.option)
        },
        deep:true
      },
      type:{
        handler:function (newValue) {
          this.option.series[0].type = newValue
          this.echartInstance.setOption(this.option)
        },
        deep:true
      }
    },
    mounted() {
      this.echartInstance = this.$chart.init(this.$refs['chart'])
      this.echartInstance.setOption(this.option)
    }
  }
</script>

<style scoped lang="scss">
  .view {
    width: 100%;
    height: 388px;
  }
</style>
